module.exports = __webpack_public_path__ + "img/mq.11614fc4.svg";